// flows
// TODO: Move this into the web/src/flows/constants file
export const ADDCARD = "ADDCARD";
export const ADDPM = "ADDPM";
export const DEPOSIT = "DEPOSIT";
export const KYC = "KYC";
export const KYC2 = "KYC2";
export const PM = "PM";
export const PAYOUT = "PAYOUT";
export const PAYOUT_FULL = "PAYOUT-FULL";
export const PAYOUTV2 = "PAYOUTV2";
export const GDPR = "GDPR";
export const PURCHASE = "PURCHASE";
export const CHECKOUT = "CHECKOUT";
export const TOS = "TOS";
export const PAYMENT_SELECTION = "PAYMENT-SELECTION";
export const PAYMENT_METHOD_MANAGEMENT = "PAYMENT-METHOD-MANAGEMENT";
export const TXNHISTORY = "TXNHISTORY";
export const TXNDETAILS = "TXNDETAILS";
export const SESSION_ID = "SESSION-ID";

// providers
export const ADYEN = "adyen";
export const REBILLY = "rebilly";

// settings / config keys
export const ALLOWBYPASSTOS = "allowBypassTOS";
export const REQUESTBYPASSTOS = "bypassTOS";

export const PRODUCTION = "production";
export const DEBUG_PREFIX = "WID";

export const FLOWS = {
  PAYPAL: "paypal",
  PLAID: "plaid",
  PM: "pm",
  TOS: "tos",
  KYC: "kyc",
  KYC2: "kyc2",
  TXNHISTORY: "txnhistory",
  TXNDETAILS: "txndetails",
};

export const FLOW_STATE = {
  BYPASS: "bypass",
  CANCEL: "cancel",
  COMPLETE: "complete",
  READY: "ready",
  ERROR: "error",
  PENDING: "pending", // KYC specific, user submitted application and is in MANUAL_REVIEW state
  DENIED: "denied", // KYC specific, user submitted application and was automatically denied (DENY state)
};

export const FORMAT = {
  IFRAME: "IFRAME",
  FULLPAGE: "FULLPAGE",
};
